// ======================================================================
// File: indentSource.js
// Module: PPE → Procurement → Indent
//
// Purpose:
// - Frontend mirror of backend IndentSource enum
// - Used for create form, filters, and display
//
// Backend reference:
// indent_models.py → IndentSource
//
// ======================================================================

const INDENT_SOURCE = {
  MANUAL: "MANUAL",
  BOQ: "BOQ",
  PLANNING: "PLANNING",
};

export default INDENT_SOURCE;
